import { render } from "./index.vue?vue&type=template&id=38704f08"
const script = {}
script.render = render

export default script